module.exports = __webpack_public_path__ + "img/图.d39abd39.png";